import React from 'react';
import { SimpleInput } from '../../../../../components/shared';

interface DesignNotesInputProps {
  onDesignNotesChange: (value: string) => void;
  designNotesValue: string;
  isEnabled: boolean;
}

export const DesignNotesInput: React.FC<DesignNotesInputProps> = ({
  onDesignNotesChange,
  designNotesValue,
  isEnabled
}) => {
  return (
    <SimpleInput
      title="Design Notes"
      label="Enter Design Notes:"
      placeholder="Enter design notes..."
      value={designNotesValue}
      onChange={onDesignNotesChange}
      isEnabled={isEnabled}
      isTextArea={true}
    />
  );
};
